import React from 'react';
import Karuselli from './Karuselli';

function RakennustyotSv() {
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <h1>Byggnadsarbeten</h1>
        <p></p>
          <h4>- Nybyggnation</h4>
          <h4>- Takarbeten</h4>
          <h4>- Alla renoveringsarbeten</h4>
          <h4>- Vattentätning av badrum</h4>
          <h4>- Basturenoveringar</h4>
          <h4>- Terrasser / Pergolor</h4>
      </div>
      <div className="carousel-container">
        <Karuselli folder="rakennustyot" imageCount={28} />
      </div>
    </div>
  );
}

export default RakennustyotSv;
